import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { StoreCreateionAllRegions } from "features/admin/core/domain/admin-store-creation-new-region.model";
import {
  AdminInserStoreCreationNewRegionRepository,
  AdminInserStoreCreationNewRegionResponse,
} from "features/admin/data/repository/admin.repository";
import { RootState } from "features/config/store";

export enum AdminInserStoreCreationNewRegionState {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: AdminInserStoreCreationNewRegionState;
  message: string;
}

const initialState: InitialState = {
  status: AdminInserStoreCreationNewRegionState.initial,
  message: "",
};

export const adminInserStoreCreationNewRegion = createAsyncThunk(
  "adminInserStoreCreationNewRegion",
  async (
    param: { newRegion: string; regionId: number | null },
    { rejectWithValue }
  ) => {
    try {
      const response: AdminInserStoreCreationNewRegionResponse =
        await AdminInserStoreCreationNewRegionRepository(param);
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }

        throw rejectWithValue(error.response.data.message);
      }
    }
  }
);

/* Main Slice */
export const adminInserStoreCreationNewRegionSlice = createSlice({
  name: "adminInserStoreCreationNewRegion",
  initialState,
  reducers: {
    resetAdminInserStoreCreationNewRegionSliceStatus: (state) => {
      state.status = AdminInserStoreCreationNewRegionState.initial;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(adminInserStoreCreationNewRegion.pending, (state) => {
        state.status = AdminInserStoreCreationNewRegionState.inProgress;
      })
      .addCase(adminInserStoreCreationNewRegion.fulfilled, (state, action) => {
        if (action.payload) {
          const { message } = action.payload;
          state.status = AdminInserStoreCreationNewRegionState.success;
          state.message = message;
        }
      })
      .addCase(adminInserStoreCreationNewRegion.rejected, (state, action) => {
        state.status = AdminInserStoreCreationNewRegionState.fail;
        state.message = action.payload as string;
      });
  },
});

export const selectAdminInserStoreCreationNewRegion = (state: RootState) =>
  state.adminInserStoreCreationNewRegion;

export const { resetAdminInserStoreCreationNewRegionSliceStatus } =
  adminInserStoreCreationNewRegionSlice.actions;

export default adminInserStoreCreationNewRegionSlice.reducer;
